import { useEffect, useState } from "react";
import { IVehicle } from "../../../../types/vehicle.type";
import VehicleCard from "./VehicleCard";
import { getImageVehicle } from "../../../../common/services/vehicles.api";
import { IVehicleVisualRecord } from "../../../../types/vehicle-visual-record.type";

type Props = {
  data: IVehicle;
};

export default function VehicleGallery(props: Props) {
  const vehiclesId = props.data._id;
  const [vehicleData, setVehicleData] = useState<IVehicleVisualRecord[]>([]);

  useEffect(() => {
    async function loadVehicleData(vehicleId: string) {
      if (!vehicleId) return;

      const { data, ok } = await getImageVehicle(vehicleId);
      if (ok) {
        const sortedData = data.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        setVehicleData(sortedData as IVehicleVisualRecord[]);
      }
    }

    setVehicleData([]);

    if (vehiclesId) loadVehicleData(vehiclesId);
  }, [vehiclesId]);

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">
        <h2 className="font-semibold text-2xl col-span-2 text-center">
          Histórico de Veículos
        </h2>
        <div className="flex flex-row flex-wrap w-full pt-8 gap-4 align-items-center justify-center">
          {vehicleData.map((record, index) => (
            <VehicleCard
              key={record._id}
              vehicleRecord={record}
              isFirstRecord={index === 0}
            />
          ))}
        </div>
      </section>
    </div>
  );
}
